/**
 * Typed error surfaced by status-machine mutations when the row's status
 * changed in the database between the caller's read and the update. UI
 * components can pattern-match on this error to render a "Someone else moved
 * this — refresh to see the latest" toast instead of a generic "Update
 * failed".
 *
 * The mutations use a `.eq('status', expectedPrev).select('id')` CAS pattern
 * and treat zero rows-affected as concurrent change; see the EF parallels
 * in supabase/functions/_shared/review-send.ts and relay-booking-cancel.
 */
export class StatusChangedConcurrentlyError extends Error {
  readonly entity: string;

  constructor(entity: string, message?: string) {
    super(
      message ??
        `Another user already changed the ${entity}'s status. Refresh to see the latest.`,
    );
    this.entity = entity;
    this.name = "StatusChangedConcurrentlyError";
  }
}

export function isStatusChangedConcurrentlyError(
  err: unknown,
): err is StatusChangedConcurrentlyError {
  return err instanceof StatusChangedConcurrentlyError;
}
